import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "../components/SEO";
import { ORG_ID } from "../data/schema";
import { Reveal, Stagger, Item, Chapter, MaskedLine } from "../components/Reveal";
import { POSTS } from "../data/posts";

export default function Blog() {
  const posts = POSTS;

  return (
    <main className="pt-36 lg:pt-44">
      <SEO
        title="Insights — Website Growth, SEO & Lead Generation | Grotech Web"
        description="Practical articles for business owners: how to build websites that generate enquiries, how SEO really works, and how to turn visitors into leads."
        path="/blog"
        schema={{ "@type": "Blog", "@id": "https://grotechweb.com/blog/#blog", name: "Grotech Web Insights", url: "https://grotechweb.com/blog/", publisher: { "@id": ORG_ID } }}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16" data-testid="blog-hero">
        <Chapter index="—" label="Insights" />
        <h1 className="mt-8 font-display text-4xl font-black leading-[1.04] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine>Websites, SEO &</MaskedLine>
          <MaskedLine delay={0.15}>
            <span className="text-white/35">Getting More Enquiries.</span>
          </MaskedLine>
        </h1>
        <Reveal hero delay={0.3}>
          <p className="mt-6 max-w-2xl text-white/60">
            Straight answers for business owners — no jargon, no fluff. What actually makes a website
            bring in business.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16 lg:py-20">
        {posts.length === 0 ? (
          <p className="py-16 text-center text-white/40" data-testid="blog-empty">
            Articles on this topic are coming soon.
          </p>
        ) : (
          <Stagger className="grid gap-6 lg:grid-cols-3">
            {posts.map((p) => (
              <Item key={p.slug}>
                <Link
                  to={`/blog/${p.slug}/`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-white/10 bg-ink p-7 transition-all duration-300 hover:-translate-y-1 hover:border-ember/40"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-ember">
                      {p.category}
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-white/20 transition-colors group-hover:text-ember" />
                  </div>
                  <h2 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight">
                    {p.title}
                  </h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-white/50">{p.excerpt}</p>
                  <div className="mt-6 flex items-center gap-3 font-mono text-[11px] text-white/35">
                    <span>{new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                    <span className="h-1 w-1 rounded-full bg-white/25" />
                    <span>{p.readTime}</span>
                  </div>
                </Link>
              </Item>
            ))}
          </Stagger>
        )}
      </section>
    </main>
  );
}
